<template>

      <div class="d-inline-flex">
        <div>
          <b-dropdown class="pb-3" variant="primary" id="date-filter">
            <template v-slot:button-content>
              {{ $t('pages.dashboard.date_filter')}} ({{selectedDuration}} Days)
              <i class="mdi mdi-alarm"></i>
            </template>
            <b-dropdown-item
                @click="setDateDuration(30)"
            >
              <span :class="{'a-duration': selectedDuration === 30}">{{ $t('pages.dashboard.last_days', {days: 30})}}</span>
            </b-dropdown-item>
            <b-dropdown-item
                @click="setDateDuration(60)"
            >
              <span :class="{'a-duration': selectedDuration === 60}">{{ $t('pages.dashboard.last_days', {days: 60})}}</span>
            </b-dropdown-item>
            <b-dropdown-item
                @click="setDateDuration(90)"
            >
              <span :class="{'a-duration': selectedDuration === 90}">{{ $t('pages.dashboard.last_days', {days: 90})}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div style="margin-left: 6px;" v-if="selectedMarketplace" id="db-marketplace">
          <b-dropdown class="pb-3" variant="primary">
            <template v-slot:button-content>
              {{ $t('pages.dashboard.marketplace')}}
              <span :class="`flag-icon flag-icon-${selectedMarketplace.value}`"> </span>
            </template>
            <template v-for="marketplace in filteredMarketPlaces">
              <b-dropdown-item @click="handleSelectedMarketplace(marketplace.marketplace_id)" :key="marketplace.value">
                <span class="option-title px-2">{{ marketplace.text }}</span>
                <span :class="`flag-icon flag-icon-${marketplace.value}`"> </span>
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "DashboardFilters",
  props: ['marketplace'],
  data() {
    return {
      selectedMarketplace: null,
      selectedDuration: 30
    }
  },
  computed: {
    ...mapGetters('marketplaces', ['marketplaces']),
    filteredMarketPlaces() {
      return this.marketplaces.filter(item => {
        return this.$auth.user().marketplaces.includes(item.marketplace_id)
      })
    }
  },
  methods: {
    handleSelectedMarketplace(marketplaceID) {
      this.selectedMarketplace = this.marketplaces.find(item => item.marketplace_id === marketplaceID)
      this.$emit('marketplace', marketplaceID)
    },
    setDateDuration(duration) {
      this.selectedDuration = duration
      this.$emit('duration', duration)
    }
  },
  created() {
    this.handleSelectedMarketplace(this.marketplace)
  }
}
</script>

<style scoped>
.a-duration {
  color: #556ee6 !important;
}
</style>